export default function getPageLoadInfo() {
  const performance = window?.performance;
  const timing = performance?.timing;
  return {
    /**
     * DNS Lookup Time: 浏览器解析域名所花费的时间
     * 含义：这是浏览器解析域名所花费的时间。它表示从开始进行 DNS 查询到 DNS 查询完成之间的时间差。
     * 重要性：较长的 DNS 查询时间可能意味着你的 DNS 服务器响应较慢，或者网络连接存在问题。
     */
    dnsLookupTime: timing?.domainLookupEnd - timing?.domainLookupStart,
    /**
     * TCP Handshake Time: 浏览器与服务器建立 TCP 连接所花费的时间
     * 含义：这是浏览器与服务器建立 TCP 连接所花费的时间。它包括了三次握手过程。
     * 重要性：较长的 TCP 握手时间可能意味着网络延迟较高，或者服务器负载较大。
     */
    tcpHandshakeTime: timing?.connectEnd - timing?.connectStart,
    /**
     * Time to First Byte (TTFB): 从浏览器发送请求到接收到服务器响应第一个字节之间的时间差
     * 含义：这是从浏览器发送请求到接收到服务器响应第一个字节之间的时间差。
     * 重要性：TTFB 是衡量服务器响应速度的重要指标。较长的 TTFB 可能表明服务器处理请求比较慢，或者网络传输速度较慢。
     */
    ttfb: timing?.responseStart - timing?.requestStart,
    /**
     * DOM Load Time: 从导航开始到 DOM 完全加载并解析完成之间的时间差
     * 含义：这是从导航开始（即用户点击链接或输入 URL）到 DOM 完全加载并解析完成之间的时间差。这不包括样式表、图片和子框架等资源，但包括内联脚本执行。
     * 重要性：DOM 加载时间反映了页面内容何时对用户可见和可交互。优化 DOM 加载时间可以提升用户体验。
     */
    domLoadTime: timing?.domContentLoadedEventEnd - timing?.navigationStart,
    /**
     * Page Load Time: 从导航开始到所有资源完全加载并执行完毕之间的总时长
     * 含义：这是从导航开始到所有资源（包括样式表、图片、脚本等）完全加载并执行完毕之间的总时长。
     * 重要性：页面加载总时间是衡量整个页面加载性能的重要指标。优化这个指标可以显著提升用户体验。
     */
    pageLoadTime:
      (timing?.loadEventEnd || new Date().getTime()) - timing?.navigationStart
  };
}
